import { GcRegistryBridgeDto, validateStrictDecoder } from "@flexidao/dto";
import { isoTimestampDecoder } from "@flexidao/helpers";
import * as D from "schemawax";

export const getTermsConditionsDecoder: D.Decoder<GcRegistryBridgeDto.GetTermsConditionsByTenantIdResponse> =
    validateStrictDecoder<GcRegistryBridgeDto.GetTermsConditionsByTenantIdResponse>()(
        D.object({
            required: {
                userId: D.nullable(D.string),
                cfeSuiteTenantId: D.string,
                firstName: D.nullable(D.string),
                surname: D.nullable(D.string),
                email: D.nullable(D.string),
                acceptedAt: D.nullable(isoTimestampDecoder),
                termsAndConditionsUrl: D.nullable(D.string),
            },
        }),
    );

export const postAcceptTermsConditionsDecoder: D.Decoder<GcRegistryBridgeDto.PostAcceptTermsConditionsByTenantIdResponse> =
    getTermsConditionsDecoder;
